const Dates = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Más recientes', label: 'Más recientes' },
    { value: 'Más antiguos', label: 'Más antiguos' },
    { value: 'Esta semana', label: 'Esta semana' },
    { value: 'Este mes', label: 'Este mes' },
    { value: 'Este año', label: 'Este año' },
    { value: 'Fecha específica', label: 'Fecha específica' },
];

const Categories = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Artículo', label: 'Artículo' },
    { value: 'Podcast', label: 'Podcast' },
    { value: 'Historias que conectan', label: 'Historias que conectan' },
    { value: 'Webinar', label: 'Webinar' },
];

const Themes = [
    { value: "Todos", label: "Todos"},
    { value: "Talento mujeres", label: "Talento mujeres"},
    { value: "Talento joven", label: "Talento joven"},
    { value: "Inclusión", label: "Inclusión"},
    { value: "Tendencias", label: "Tendencias"},
    { value: "Talento 4.0", label: "Talento 4.0"},
    { value: "Documentos", label: "Documentos"},
]

export { Dates, Categories, Themes }